import React from 'react'
import LandingPage from '../../components/landingpage/LandingPage'

const Home = () => {
  return (
    <LandingPage/>
  )
}

export default Home